<template>
  <div class="nav-container row">
    <div class="menu-button "
         :class="language==='en'?'thumb-en':'thumb-zh'"
         v-if="menuListParse.thumb"
         @click="showModule('thumb')">
    </div>
    <div class="menu-button"
         :class="language==='en'?'content-en':'content-zh'"
         v-if="menuListParse.content"
         @click="toggle('content')"
         v-click-outside="()=>{menuShow.content=false}">
      <slot>
        <div class="box"
             :class="{'act':menuShow.content}">
          <ul class="menu-button-list"
              :class="{'show':menuShow.content}">
            <li class="item-one"
                @click="handdleClick(menuListParse.content.cnContentPage)"></li>
            <li class="item-two"
                @click="handdleClick(menuListParse.content.enContentPage)"></li>

          </ul>
        </div>
      </slot>
    </div>
    <div class="menu-button "
         :class="language==='en'?'supplier-en':'supplier-zh'"
         @click="toggle('supplier')"
         v-click-outside="()=>{menuShow.supplier=false}"
         v-if="menuListParse.supplier">
      <slot>
        <div class="box supplier"
             :class="{'act':menuShow.supplier}">
          <ul class="menu-button-list"
              :class="{'show':menuShow.supplier}">
            <li class="item-one"
                @click="handdleClick(menuListParse.supplier.clientSuppliersUrl)"></li>
            <li class="item-two"
                @click="handdleClick(menuListParse.supplier.clientSupplierSearchUrl)"></li>
            <li class="item-three"
                @click="handdleClick(menuListParse.supplier.clientProductSearchUrl)"></li>
          </ul>
        </div>
      </slot>
    </div>
    <div class="menu-button "
         :class="language==='en'?'adver-en':'adver-zh'"
         @click="handdleClick(menuListParse.advertiser.advertiserPage)"
         v-if="menuListParse.advertiser">
    </div>
    <div class="menu-button "
         :class="language==='en'?'read-en':'read-zh'"
         @click="handdleClick(menuListParse.subscription.clientSubscriptionUrl)"
         v-if="menuListParse.subscription">
    </div>
    <div class="menu-button "
         :class="language==='en'?'video-en':'video-zh'"
         @click="handdleClick(menuListParse.video.clientVideoUrl)"
         v-if="menuListParse.video">
    </div>
    <div class="menu-button "
         :class="language==='en'?'seminar-en':'seminar-zh'"
         @click="handdleClick(menuListParse.seminar.clientSeminarUrl)"
         v-if="menuListParse.seminar">
    </div>
    <div class="menu-button "
         :class="language==='en'?'rgseminar-en':'rgseminar-zh'"
         @click="handdleClick(menuListParse.rgseminar.ringerSeminarUrl)"
         v-if="menuListParse.rgseminar">

    </div>
    <div class="menu-button "
         :class="language==='en'?'sdshow-en':'sdshow-zh'"
         @click="handdleClick(menuListParse.sdshow.sdShowUrl)"
         v-if="menuListParse.sdshow">
    </div>
    <div class="menu-button"
         :class="language==='en'?'magzine-en':'magzine-zh'"
         v-if="menuListParse.magazine"
         @click="toggle('magzine')"
         v-click-outside="()=>{menuShow.magzine=false}">
      <slot>
        <div class="box magzine"
             :class="{'act':menuShow.magzine}">
          <ul class="menu-button-list"
              :class="{'show':menuShow.magzine}">
            <li class="item-one"
                @click="handdleClick(menuListParse.magazine.clientMagazineAboutUrl)"></li>
            <li class="item-two"
                @click="handdleClick(menuListParse.magazine.clientMagazineDownLoadUrl)"></li>
            <li class="item-three"
                @click="handdleClick(menuListParse.magazine.clientMagazineServiceUrl)"></li>
          </ul>
        </div>
      </slot>
    </div>
    <div class="menu-button "
         :class="language==='en'?'share-en':'share-zh'"
         @click="showModule('share')"
         v-if="menuListParse.share">
    </div>
    <div class="menu-button "
         :class="language==='en'?'print-en':'print-zh'"
         @click="showModule('print')"
         v-if="menuListParse.print">
    </div>
    <div class="menu-button "
         :class="language==='en'?'help-en':'help-zh'"
         v-if="menuListParse.help"
         @click="showModule('help')">
    </div>
    <div class="menu-button "
         :class="language==='en'?'close-en':'close-zh'"
         v-if="menuListParse.close"
         @click="close">
    </div>
  </div>
</template>
<script>
import ClickOutside from 'vue-click-outside';
import { isNumber, validURL } from '@/utils';
import { mapState } from 'vuex';

export default {
  props: {
    menuList: Array,
    // language: String,
  },
  mounted() {
    // console.log('menu', this.menuList);
  },
  data() {
    return {
      menuShow: {
        content: false,
        supplier: false,
        magzine: false,
      },
      // menuListParse: {},
    };
  },
  methods: {
    hide() {
      this.content = false;
    },
    toggle(name) {
      this.menuShow[name] = !this.menuShow[name];
    },
    handdleClick(s) {
      if (isNumber(s)) {
        this.gotoPage(s);
      } else if (s instanceof Object) {
        const url = this.language === 'en' ? s.en : s.cn;
        if (validURL(url)) {
          window.open(url, 'top');
        }
      }
    },
    gotoPage(n) {
      // 跳转到指定页
      this.$store.commit('updateCurrentPage', {
        currentPage: parseInt(n / 2, 0),
      });
    },
    close() {
      window.opener = null;
      window.open('', '_self');
      window.close();
    },
    showModule(name) {
      this.$store.commit('updateView', {
        view: name,
      });
    },
  },
  computed: {
    ...mapState({
      language: (state) => state.language,
    }),
    menuListParse() {
      const arr = {};
      this.menuList.forEach((element) => {
        arr[element.name] = element;
      });
      return arr;
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>
<style lang="less" scoped>
.nav-container {
  //width: 350px;
  height: 30px;
  background: #090e18;
  display: flex;
  .menu-button {
    width: 100px;
    height: 30px;
    line-height: 30px;
    background-color: #30353d;
    background-position: center;
    font-size: 10px;
    cursor: pointer;
    color: white;
    margin-left: 3px;
    .box {
      width: 84px;
      bottom: 66px;
      overflow: hidden;
      position: relative;
      pointer-events: none;
      .show {
        opacity: 1;
        transform: translateY(0%);
      }
    }
    .act {
      pointer-events: visible;
    }
    &-list {
      transition: all 0.5s;
      transform: translateY(100%);
      position: relative;
      bottom: 0px;
      left: 0;
      // width: 84px;
      margin: 0;
      padding: 0;
      opacity: 0;
      overflow: hidden;
      li:hover {
        background-color: transparent;
        opacity: 0.8;
      }
    }
    .supplier {
      width: 145px;
      bottom: 99px;
    }
    .magzine {
      width: 85px;
      bottom: 99px;
    }
  }
  .menu-button:hover {
    background-color: grey;
  }
  .menu-button.content-zh {
    .item-one {
      background-image: url("~@/assets/icon/icon_contents_chi.png");
      margin-bottom: 3px;
    }
    .item-two {
      background-image: url("~@/assets/icon/icon_contents_eng.png");
      margin-bottom: 3px;
    }
    background-image: url("~@/assets/icon/icon_index.png");
    width: 65px;
  }
  .menu-button.content-en {
    .item-one {
      background-image: url("~@/assets/icon/icon_contents_chi.png");
      margin-bottom: 3px;
    }
    .item-two {
      background-image: url("~@/assets/icon/icon_contents_eng.png");
      margin-bottom: 3px;
    }
    background-image: url("~@/assets/icon/icon_index_eng.png");
    width: 65px;
  }
  .menu-button.thumb-zh {
    background-image: url("~@/assets/icon/icon_overview.png");
    width: 65px;
  }
  .menu-button.thumb-en {
    background-image: url("~@/assets/icon/icon_overview_eng.png");
    width: 85px;
  }
  .menu-button.supplier-zh {
    .item-one {
      background-image: url("~@/assets/icon/icon_suppliers.png");
      margin-bottom: 3px;
    }
    .item-two {
      background-image: url("~@/assets/icon/icon_supplierSearch.png");
      margin-bottom: 3px;
    }
    .item-three {
      background-image: url("~@/assets/icon/icon_productSearch.png");
      margin-bottom: 3px;
    }
    .supplier {
      width: 118px;
      bottom: 99px;
    }
    background-image: url("~@/assets/icon/icon_supplier.png");
    width: 118px;
  }
  .menu-button.supplier-en {
    .item-one {
      background-image: url("~@/assets/icon/icon_suppliers_eng.png");
      margin-bottom: 3px;
    }
    .item-two {
      background-image: url("~@/assets/icon/icon_supplierSearch_eng.png");
      margin-bottom: 3px;
    }
    .item-three {
      background-image: url("~@/assets/icon/icon_productSearch_eng.png");
      margin-bottom: 3px;
    }
    .supplier {
      width: 145px;
      bottom: 99px;
    }
    background-image: url("~@/assets/icon/icon_supplier_eng.png");
    width: 145px;
  }

  .menu-button.adver-zh {
    background-image: url("~@/assets/icon/icon_advertiser.png");
    width: 95px;
  }
  .menu-button.adver-en {
    background-image: url("~@/assets/icon/icon_advertiser_eng.png");
    width: 95px;
  }
  .menu-button.read-zh {
    background-image: url("~@/assets/icon/icon_read.png");
    width: 64px;
  }
  .menu-button.read-en {
    background-image: url("~@/assets/icon/icon_read_eng.png");
    width: 85px;
  }
  .menu-button.magzine-zh {
    .item-one {
      background-image: url("~@/assets/icon/icon_about.png");
      margin-bottom: 3px;
    }
    .item-two {
      background-image: url("~@/assets/icon/icon_download.png");
      margin-bottom: 3px;
    }
    .item-three {
      background-image: url("~@/assets/icon/icon_service.png");
      margin-bottom: 3px;
    }
    background-image: url("~@/assets/icon/icon_magazine.png");
    width: 65px;
  }
  .menu-button.magzine-en {
    .item-one {
      background-image: url("~@/assets/icon/icon_about_eng.png");
      margin-bottom: 3px;
    }
    .item-two {
      background-image: url("~@/assets/icon/icon_download_eng.png");
      margin-bottom: 3px;
    }
    .item-three {
      background-image: url("~@/assets/icon/icon_service_eng.png");
      margin-bottom: 3px;
    }
    background-image: url("~@/assets/icon/icon_magazine_eng.png");
    width: 65px;
  }
  .menu-button.share-zh {
    background-image: url("~@/assets/icon/icon_share.png");
    width: 64px;
  }
  .menu-button.share-en {
    background-image: url("~@/assets/icon/icon_share_eng.png");
    width: 64px;
  }
  .menu-button.print-zh {
    background-image: url("~@/assets/icon/icon_print.png");
    width: 64px;
  }
  .menu-button.print-en {
    background-image: url("~@/assets/icon/icon_print_eng.png");
    width: 64px;
  }
  .menu-button.help-zh {
    background-image: url("~@/assets/icon/icon_help.png");
    width: 64px;
  }
  .menu-button.help-en {
    background-image: url("~@/assets/icon/icon_help_eng.png");
    width: 64px;
  }
  .menu-button.close-zh {
    background-image: url("~@/assets/icon/close.png");
    width: 64px;
  }
  .menu-button.close-en {
    background-image: url("~@/assets/icon/close_eng.png");
    width: 64px;
  }
  .menu-button.video-zh {
    background-image: url("~@/assets/icon/cn/ivideo.png");
  }
  .menu-button.video-en {
    background-image: url("~@/assets/icon/en/ivideo.png");
  }
  .menu-button.seminar-en {
    background-image: url("~@/assets/icon/en/seminar.png");
  }
  .menu-button.seminar-zh {
    background-image: url("~@/assets/icon/cn/seminar.png");
  }
  .menu-button.rgseminar-en {
    background-image: url("~@/assets/icon/en/rgseminar.png");
    width: 130px;
  }
  .menu-button.rgseminar-zh {
    background-image: url("~@/assets/icon/cn/rgseminar.png");
  }
  .menu-button.sdshow-en {
    background-image: url("~@/assets/icon/en/isdshow.png");
  }
  .menu-button.sdshow-zh {
    background-image: url("~@/assets/icon/cn/isdshow.png");
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 2.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  //opacity: 0;
  transform: translateY(0%);
}
</style>
